import {Affiliate} from '../../../../shared/types';
import {getDateDiff, TimeInSeconds} from '../../../../shared/utils/DateUtils';

export default function(affiliate: Affiliate) {
    if (!affiliate || !affiliate.payoutSetupInfo) return 0;

    const {payoutSetupInfo} = affiliate;
    const {completed, dueDate} = payoutSetupInfo || {};

    if (completed) {
        return 0;
    }

    const daysLeft = dueDate ? getDateDiff(Date.now(), dueDate, TimeInSeconds.DAY) : 0;

    if (daysLeft < 0) {
        return 0;
    }

    return `${daysLeft + 1}`;
}
